<template>
  <div
    v-if="messageInList.id && showLoadingState"
    key="loadingMessage"
    class="m-edition-map-messages-record"
  >
    <p class="margin-top-xxlarge text-align-center">
      Cargando datos...
    </p>
  </div>
  <div
    v-else-if="messageInList.id"
    key="messageLoaded"
    class="m-edition-map-messages-record"
  >
    <div class="messages-record-header">
      <h2>
        {{ $store.getters.getAssetSelectedNode.titulo }}
      </h2>
      <form autocomplete="off" name="editor-form" v-if="false">
        <button
          type="submit"
          class="a-button-primary a-button-billing-primary a-button-assets-primary margin-left-auto"
          @click.prevent="editNode"
        >
          <i class="fas fa-pencil margin-right-xsmall"></i>
          <span>Editar</span>
        </button>
      </form>
    </div>
    <MoleculeContentNode :is-task="false"/>
    <div class="m-edition-asset-comments">
      <MoleculeEditionAssetCommentsReplies
        :comentarios-tipo="comentariosTipo"
        :comment="message"
        :contenido="this.$store.getters.getAssetContents[0]"
        :is-child="false"
        @reloadMessage="reloadMessage"
      />
    </div>
  </div>
  <div
    v-else
    key="emptyMessage"
    class="m-edition-map-messages-record"
  >
  </div>
</template>

<script>
export default {
  name: 'MoleculeEditionMapMessagesRecord',

  components: {
    MoleculeEditionAssetCommentsReplies: () => import('@/components/molecules/MoleculeEditionAssetCommentsReplies'),
    MoleculeContentNode: () => import('@/components/molecules/MoleculeContentNode')
  },

  data () {
    return {
      comentariosTipo: 2,
      message: {},
      showLoadingState: true
    }
  },

  computed: {
    messageInList () {
      return this.$store.getters.getAssetSelectedMessageInList
    },

    updatedData () {
      return this.$modal.updatedData
    }
  },

  watch: {
    messageInList () {
      this.showLoadingState = true
      this.readComentario()
    },

    updatedData () {
      this.readComentario()
    }
  },

  methods: {
    editNode () {
      this.$router.push(`/${this.$t('rPaths.map')}/${this.$route.params.id}/${this.$t('mEditionMenu.map.path.subject')}`)
    },

    readComentario () {
      if (this.$store.getters.getAssetSelectedMessageInList.id) {
        this.$services.read('proyecto', 'readComentario', {}, [this.$store.getters.getAssetSelectedMessageInList.id]
          , { academia: this.$store.getters.getAcademyData.id })
          .then(response => {
            this.message = Object.assign({}, response.data)
            this.setSelectedNode()
            this.showLoadingState = false
          })
          .catch(error => {
            console.log(error)
            this.showLoadingState = false
          })
      }
    },

    reloadMessage () {
      this.readComentario()
    },

    setSelectedNode () {
      let proyectNodes = [...this.$store.getters.getAssetNodes]

      proyectNodes.every((pNode, index) => {
        let returnState = true
        if (pNode.id === this.$store.getters.getAssetSelectedMessageInList.nodo) {
          this.$store.commit('setAssetSelectedNode', Object.assign({}, pNode))
          returnState = false
        } else {
          pNode.children.every((pNodeChild, indexChild) => {
            if (pNodeChild.id === this.$store.getters.getAssetSelectedMessageInList.nodo) {
              this.$store.commit('setAssetSelectedNode', Object.assign({}, pNodeChild))
              returnState = false
            }
            return returnState
          })
        }
        return returnState
      })
    }
  }
}
</script>
